import Box from '@mui/material/Box';
import { getCategoryColor } from './category-color';

type BadgeProps = {
  badge: string;
  category: string;
  size?: number;
  /** Overrides the category colour, for a badge that is not a product. */
  color?: string;
};

function ProductBadge({ badge, category, size = 26, color }: BadgeProps) {
  let background = getCategoryColor(category);
  if (color !== undefined) {
    background = color;
  }
  return (
    <Box
      aria-hidden="true"
      sx={{
        width: size,
        height: size,
        borderRadius: '6px',
        bgcolor: background,
        color: 'var(--color-category-badge-text)',
        fontSize: '11px',
        fontWeight: 700,
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {badge}
    </Box>
  );
}

export { ProductBadge };
export type { BadgeProps };
